module.exports = __webpack_public_path__ + "img/shop-custom-seat-covers.1c9106a8.jpg";